import { render, staticRenderFns } from "./widgetPeopleFlow.vue?vue&type=template&id=bd68592c"
import script from "./widgetPeopleFlow.vue?vue&type=script&lang=js"
export * from "./widgetPeopleFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports